import { CollectionState } from "./BaseModel";
import {
    NotificationCollectionMeta,
    NotificationDTO,
} from "./dto/NotificationDTO";

interface NotificationCollection extends CollectionState<NotificationDTO> {
    page: number;
}

export interface NotificationsState {
    readCollection: NotificationCollection;
    unreadCollection: NotificationCollection;
    shortCollection: CollectionState<
        NotificationDTO,
        NotificationCollectionMeta
    >;
}

export const InitialNotifications: NotificationsState = {
    readCollection: {
        rows: [],
        totalPages: 0,
        totalRows: 0,
        page: 0,
    },
    unreadCollection: {
        rows: [],
        totalPages: 0,
        totalRows: 0,
        page: 0,
    },
    shortCollection: {
        rows: [],
        totalPages: 0,
        totalRows: 0,
        meta: {
            unreadCount: 0,
        },
    },
};
